module.exports = __webpack_public_path__ + "static/media/pic6.609902f7.jpg";